const initPagesSliderWidget = () => {
    const flickitySlidersArray = initCarousel("[data-pages-slider] [data-slider]", cellAlign.left, true, false, true, false, false, null, true);
    const flickityImageSlidersArray = initCarousel("[data-pages-slider] [data-image-slider]", cellAlign.left, true, false, true, false, false, null, true);
    flickitySlidersArray && flickitySlidersArray.forEach(flickitySlider => {
        //custom binding to buttons
        const prevButton = flickitySlider.slider.closest("[data-pages-slider]").querySelector("[data-prev-button]");
        if (prevButton) {
            //custom binding to prev button
            prevButton.addEventListener("click", () => {
                flickitySlider.previous();
            });
        }
        //custom binding to next button
        const nextButton = flickitySlider.slider.closest("[data-pages-slider]").querySelector("[data-next-button]");
        if (nextButton) {
            nextButton.addEventListener("click", () => {
                flickitySlider.next();
            });
        }
    });
    flickityImageSlidersArray && flickityImageSlidersArray.forEach(flickityImageSlider => {
        const slider = flickityImageSlider.slider;
        //show current slide index
        const currentSlideIndex = slider.parentElement.parentElement.parentElement.querySelector("[data-current-slide-index]");
        if (currentSlideIndex) {
            flickityImageSlider.on("change", () => {
                currentSlideIndex.innerHTML = (flickityImageSlider.selectedIndex + 1).toString();
            });
        }
        //custom binding to prev button
        const prevButton = slider.parentElement.parentElement.parentElement.querySelector("[data-prev-image-button]");
        prevButton.addEventListener("click", () => {
            flickityImageSlider.previous();
        });
        //custom binding to next button
        const nextButton = slider.parentElement.parentElement.parentElement.querySelector("[data-next-image-button]");
        nextButton.addEventListener("click", () => {
            flickityImageSlider.next();
        });
    });
};
